module.exports = __webpack_public_path__ + "assets/img/download-btn-b3e5458b.png";